export default "__VITE_ASSET__DPC3pmGl__"